import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=16ffaf6c&"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports